import React from 'react';

import { Alert } from 'antd';

const Atention = () => {
  return (
    <Alert
      className='mt-2'
      type='info'
      showIcon
      message={
        'Atenção: Em páginas de vendas que são abertas a partir de APP\'s de redes sociais, links com o atributo html target="blank" podem não funcionar. Recomendamos que o atributo não seja utilizado.'
      }
    />
  );
};

export default Atention;
